import { IFilterSettings } from "Domain/Repository/BaseRepository/BaseRepository";

export const FIND_SPOT_LISTS_REQUEST = 'FIND_SPOT_LISTS_REQUEST';

export const findSpotListsRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }: IFilterSettings ) => ({
    type: FIND_SPOT_LISTS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
